var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"open":_vm.open,"title":_vm.title,"close-label":_vm.closeLabel,"size":_vm.size},on:{"close":_vm.closeModal}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }